import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary-dark to-darker-bg" />
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      {/* Decorative Blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary-light/20 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-sm font-medium text-white mb-8">
            <Icon name="BoltIcon" size={16} variant="solid" />
            <span>Get Started Today</span>
          </div>

          {/* Heading */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Ready to Elevate Your Property Maintenance?
          </h2>
          
          <p className="text-lg md:text-xl text-slate-200 mb-10 leading-relaxed max-w-2xl mx-auto">
            Join the growing number of property managers who trust OS Property Services for comprehensive, reliable maintenance solutions.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link
              href="/contact"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-primary rounded-xl hover:bg-slate-100 transition-all duration-300 text-base font-bold shadow-xl hover:shadow-2xl hover:scale-105"
            >
              <Icon name="DocumentTextIcon" size={20} variant="solid" />
              <span>Request a Quote</span>
              <Icon name="ArrowRightIcon" size={18} variant="outline" className="group-hover:translate-x-1 transition-transform" />
            </Link>
            
            <Link
              href="/services"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-white text-white rounded-xl hover:bg-white hover:text-primary transition-all duration-300 text-base font-bold"
            >
              <Icon name="WrenchScrewdriverIcon" size={20} variant="outline" />
              <span>Explore Services</span>
            </Link>
          </div>

          {/* Features */}
          <div className="grid sm:grid-cols-3 gap-6 pt-8 border-t border-white/20">
            <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="p-3 bg-white/10 rounded-lg">
                <Icon name="ClockIcon" size={24} variant="outline" className="text-white" />
              </div>
              <div>
                <p className="font-semibold text-white mb-1">24/7 On-Call Availability</p>
                <p className="text-sm text-slate-300">Always available when you need us</p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="p-3 bg-white/10 rounded-lg">
                <Icon name="ShieldCheckIcon" size={24} variant="outline" className="text-white" />
              </div>
              <div>
                <p className="font-semibold text-white mb-1">Fully Insured</p>
                <p className="text-sm text-slate-300">Licensed & certified professionals</p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="p-3 bg-white/10 rounded-lg">
                <Icon name="StarIcon" size={24} variant="solid" className="text-white" />
              </div>
              <div>
                <p className="font-semibold text-white mb-1">Trusted Service</p>
                <p className="text-sm text-slate-300">100+ properties maintained</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
